import { useMutation } from 'react-query';

import { addUser } from 'shared/api/users/http';

const useMutateAddUser = (options = undefined) => useMutation(addUser, options);

export default useMutateAddUser;
